<template>
  <div
    class="loader-container"
    data-external="page-skeleton-loader-container"
    :style="{ height: pageHeight + 'px' }"
  >
    <div v-if="timeoutCompleted" class="timeout-container">
      <FriedH2 class="timeout-message">{{ timeoutMessage }}</FriedH2>
    </div>
    <template v-else>
      <FriedSkeleton class="heading" :type="SkeletonType.H1" />
      <FriedSkeleton class="paragraph" :type="SkeletonType.Paragraph" />
      <FriedSkeleton class="sub-heading" :type="SkeletonType.H2" />
      <FriedSkeleton class="paragraph" :type="SkeletonType.Paragraph" :rows="10" />
      <FriedSkeleton class="sub-heading" :type="SkeletonType.H2" />
      <FriedSkeleton class="paragraph" :type="SkeletonType.Paragraph" :rows="14" />
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { SkeletonType } from '@getaccept/fried-tofu';

export default defineComponent({
  name: 'PageSkeletonLoader',
  props: {
    pageHeight: {
      type: Number,
      required: true,
    },
    timeout: {
      type: Number,
      default: null,
    },
    timeoutMessage: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const timeoutCompleted = ref(false);

    onMounted(() => {
      if (props.timeout) {
        setTimeout(() => (timeoutCompleted.value = true), props.timeout);
      }
    });

    return {
      timeoutCompleted,
      SkeletonType,
    };
  },
});
</script>

<style lang="scss" scoped>
.loader-container {
  padding: var(--spacing-200);
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-100);

  .heading {
    margin-top: var(--spacing-200);
    width: 70%;
  }

  .sub-heading {
    margin-top: var(--spacing-100);
    width: 60%;
  }

  .paragraph {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-50);
  }

  .timeout-container {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
}
</style>
